import { FC, ReactElement } from 'react';

import { TooltipWrap } from 'components/ui/TooltipWrap';

interface TimelineTooltipProps {
  isTimeline?: boolean;
  children: ReactElement;
}

export const TimelineTooltip: FC<TimelineTooltipProps> = ({
  isTimeline,
  children,
}) =>
  !isTimeline ? (
    children
  ) : (
    <TooltipWrap title={'Фильтр недоступен при включенном таймлайне'}>
      {children}
    </TooltipWrap>
  );
